export default __webpack_public_path__ + "67336e983c459253ba4cb14416c2edcb.svg";